import { render, staticRenderFns } from "./spotDetail.vue?vue&type=template&id=0010832b&scoped=true&"
import script from "./spotDetail.vue?vue&type=script&lang=js&"
export * from "./spotDetail.vue?vue&type=script&lang=js&"
import style0 from "./spotDetail.vue?vue&type=style&index=0&id=0010832b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0010832b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0010832b')) {
      api.createRecord('0010832b', component.options)
    } else {
      api.reload('0010832b', component.options)
    }
    module.hot.accept("./spotDetail.vue?vue&type=template&id=0010832b&scoped=true&", function () {
      api.rerender('0010832b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/scenicTutorials/components/spotDetail.vue"
export default component.exports